// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2314":"3b45534f","3672":"1831850d","7799":"050ebf81"}[chunkId] + ".chunk.css";
};